import { Module } from '../utils/_application'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

const $ = jQuery

export default class MapTooltip extends Module {
  ready (app) {
    this.tooltips = document.querySelectorAll('.mtt-map-widget .pin')

    if (this.tooltips.length) {
      for (let i = 0; i < this.tooltips.length; i++) {
        const tooltip = this.tooltips[i]

        new Tooltip(tooltip)
      }
    }

    this.showTooltipOnCountryClick()
  }

  showTooltipOnCountryClick () {
    this.countries = document.querySelectorAll('.mtt-map-widget__country')

    if (this.countries.length) {
      for (let i = 0; i < this.countries.length; i++) {
        const country = this.countries[i]

        country.addEventListener('click', () => {
          const dataID = country.getAttribute('data-id')
          const matchingPin = document.querySelector('.mtt-map-widget__pin[data-id="' + dataID + '"]')

          matchingPin.click()
        })
      }
    }
  }
}

class Tooltip {
  constructor (tooltip) {
    this.tooltip = tooltip

    this.createTooltip()
  }

  createTooltip () {
    const country = this.tooltip.getAttribute('data-id') ? this.tooltip.getAttribute('data-id') : ''
    const desc = this.tooltip.getAttribute('data-desc') ? this.tooltip.getAttribute('data-desc') : ''
    const subdesc = this.tooltip.getAttribute('data-subdesc') ? this.tooltip.getAttribute('data-subdesc') : ''

    const content =
    '<div class="content-wrapper">' +
      '<div class="title"> <div>' + country + '</div> </div>' +
      '<p class="desc">' + desc + '</p>' +
      '<p class="subdesc">' + subdesc + '</p>' +
    '</div>'

    const that = this

    tippy(this.tooltip, {
      content: content,
      allowHTML: true,
      placement: 'bottom-start',
      theme: 'light',
      zIndex: 10,
      trigger: 'click',
      onShow () {
        that.highlightCountry()
      },
      onHide () {
        that.unHighlightCountry()
      }
    })
  }

  highlightCountry () {
    const dataID = this.tooltip.getAttribute('data-id')
    const matchingCountry = document.querySelector('.mtt-map-widget__country[data-id="' + dataID + '"]')

    matchingCountry.classList.add('highlight')
  }

  unHighlightCountry () {
    const dataID = this.tooltip.getAttribute('data-id')
    const matchingCountry = document.querySelector('.mtt-map-widget__country[data-id="' + dataID + '"]')

    matchingCountry.classList.remove('highlight')
  }
}
